module.exports = __webpack_public_path__ + "img/58.e19b6296.jpg";